import Label from './label.component';
import { MAX_LABEL_WIDTH } from './constants';
export default Label;
export { MAX_LABEL_WIDTH };
